import { Box } from "@mui/material";

export const SpaceComponent = () => {
  return <Box sx={{ m: 3 }} />;
};
